var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3001_118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.63585 9.293L11.2929 3.636C11.4804 3.44853 11.7347 3.34322 11.9999 3.34322C12.265 3.34322 12.5193 3.44853 12.7069 3.636L18.3639 9.293C18.546 9.4816 18.6468 9.7342 18.6445 9.9964C18.6423 10.2586 18.5371 10.5094 18.3517 10.6948C18.1663 10.8802 17.9155 10.9854 17.6533 10.9877C17.3911 10.99 17.1385 10.8892 16.9499 10.707L12.9999 6.757V20C12.9999 20.2652 12.8945 20.5196 12.707 20.7071C12.5194 20.8946 12.2651 21 11.9999 21C11.7346 21 11.4803 20.8946 11.2927 20.7071C11.1052 20.5196 10.9999 20.2652 10.9999 20V6.757L7.04985 10.707C6.95761 10.8025 6.84726 10.8787 6.72526 10.9311C6.60325 10.9835 6.47204 11.0111 6.33926 11.0123C6.20648 11.0134 6.0748 10.9881 5.9519 10.9378C5.829 10.8875 5.71735 10.8133 5.62346 10.7194C5.52957 10.6255 5.45531 10.5139 5.40503 10.391C5.35475 10.2681 5.32945 10.1364 5.3306 10.0036C5.33176 9.87082 5.35934 9.7396 5.41175 9.6176C5.46416 9.49559 5.54034 9.38525 5.63585 9.293Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3001_118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopArrow);
export default __webpack_public_path__ + "static/media/top_arrow.c18dae2c824934a00d3ecbd75669465c.svg";
export { ForwardRef as ReactComponent };